export class AppPattern{
    public PAN_PATTERN = "[A-Z]{5}[0-9]{4}[A-Z]{1}";
    public AADHAR_PATTERN = "[0-9]{12}";
     public GST_PATTERN="^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$";
  }
